export default __webpack_public_path__ + "static/media/garden-preview.80cab7b1.jpg";